import { styled, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  notInvoicesText: {
    fontStyle: 'italic',
    fontWeight: 500,
    fontSize: 14,
    color: '#767676',
    marginBottom: 20,
  },
}));

export const NotInvoicesText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  marginBottom: 20,
  color: theme.palette.text.disabled,
}));
